<template>
  <div v-if="error" class="error">
    <UiBaseIcon class="error-icon" icon-name="exclamation" width="11px" height="11px" />
    <span class="error-text">{{ error }} </span>
  </div>
</template>

<script>
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

export default {
  components: { UiBaseIcon },
  props: {
    error: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.error {
  @include createFlex(flexbox, nowrap, row, flex-start, center, center);

  &-text {
    margin: 0 0 0 rem(4px);
    line-height: 1.3;
  }

  &-icon {
    @include square(11px);
    @include flex-shrink(0);
  }
}
</style>
